import {
  alpha,
  Autocomplete,
  Chip,
  CircularProgress,
  ListItem,
  ListItemText,
  Stack,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import * as React from 'react';

export default function EmailAutocomplete({ onBlur, placeholder, ...props }) {
  const { value } = { ...props };
  const theme = useTheme();

  return (
    <Autocomplete
      slotProps={{
        popper: {
          sx: {
            border: `2px solid`,
            borderColor: 'secondary.light',
            borderRadius: 2,
            overflow: 'hidden',
          },
        },
        listbox: {
          sx: {
            padding: 0,
          },
        },
      }}
      {...props}
      getOptionLabel={(option) => option.label}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={`${option.value}_${index}`}
            label={option.label}
          />
        ))
      }
      renderOption={(props, option) => (
        <ListItem
          {...props}
          key={`${option.value}_${option.label}`}
          sx={{
            padding: 0,
            '&:nth-of-type(even)': {
              backgroundColor: alpha(theme.palette.secondary.light, 0.15),
            },
          }}>
          <ListItemText sx={{ padding: 0 }}>
            <Stack
              sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography variant="span">{option.label}</Typography>
              <Stack
                sx={{
                  flexDirection: 'row',
                  gap: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <Typography variant="span">{option.type}</Typography>
                {option.status && option.status === 'unverified' && (
                  <CircularProgress size={10} color="secondary" />
                )}
              </Stack>
            </Stack>
          </ListItemText>
        </ListItem>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={placeholder || 'Select email addresses'}
          onBlur={onBlur}
          sx={{
            '& .MuiAutocomplete-input': {
              '&::placeholder': {
                color: 'grey',
              },
            },
          }}
        />
      )}
    />
  );
}
